import { appGQLFields } from '../app/app.fields.js';
import { memberGQLFields } from '../network/member.fields.js';
import { networkGQLFields } from '../network/network.fields.js';
import { postGQLFields } from '../post/posts.fields.js';
import { tagGQLFields } from '../post/tag.fields.js';
import { spaceGQLFields } from '../space/space.fields.js';
const BASIC_REPORT_ENTITIES_FIELDS = {
    actor: 'basic',
    app: 'basic',
    member: 'basic',
    network: 'basic',
    post: 'basic',
    space: 'basic',
    tag: 'basic',
};
const ALL_REPORT_ENTITIES_FIELDS = {
    actor: 'all',
    app: 'all',
    member: 'all',
    network: 'all',
    post: 'all',
    space: 'all',
    tag: 'all',
};
export const reportEntitiesGQLFields = (fields) => {
    if (fields === 'basic')
        fields = BASIC_REPORT_ENTITIES_FIELDS;
    if (fields === 'all')
        fields = ALL_REPORT_ENTITIES_FIELDS;
    return `
    __typename
    ${fields.actor
        ? `
    actor {
      ${memberGQLFields(fields.actor)}
    }
    `
        : ``}
    ${fields.app
        ? `
    app {
      ${appGQLFields(fields.app)}
    }
    `
        : ``}
    ${fields.member
        ? `
    member {
      ${memberGQLFields(fields.member)}
    }
    `
        : ``}
    ${fields.network
        ? `
    network {
      ${networkGQLFields(fields.network)}
    }
    `
        : ``}
    ${fields.post
        ? `
      post {
        ${postGQLFields(fields.post)}
      }
    `
        : ``}
    ${fields.space
        ? `
      space {
        ${spaceGQLFields(fields.space)}
      }
    `
        : ``}
    ${fields.tag
        ? `
      tag {
        ${tagGQLFields(fields.tag)}
      }
    `
        : ``}
  `;
};
//# sourceMappingURL=reportEntitiesFields.js.map